import React from 'react';
import PreviewRouteMap from './PreviewRouteMap';
import { SAMPLE_LOAD, SAMPLE_STOPS } from './samples';

const RoutePlanPreview = () => (
  <div className="dp-page">
    <header className="dp-page-header dp-page-header--route">
      <div>
        <p className="dp-eyebrow">Route planner</p>
        <h1 className="dp-title">
          {SAMPLE_LOAD.freight_number}
          <span className="dp-badge dp-badge--published">Published</span>
        </h1>
        <p className="dp-lead">
          {SAMPLE_LOAD.assignments.depot} → Walker, MI → Concord, NC ·{' '}
          {SAMPLE_LOAD.assignments.driver} · Truck {SAMPLE_LOAD.assignments.truck}
        </p>
      </div>
      <div className="dp-header-actions">
        <button type="button" className="dp-btn dp-btn--ghost">
          Export
        </button>
        <button type="button" className="dp-btn dp-btn--secondary">
          Edit plan
        </button>
      </div>
    </header>

    <div className="dp-route-layout">
      <section className="dp-panel dp-panel--map">
        <div className="dp-panel__toolbar">
          <span className="dp-panel__title">Route map</span>
          <span className="dp-badge dp-badge--neutral">3 legs · depot included</span>
        </div>
        <PreviewRouteMap />
        <p className="dp-map-caption">
          Decorative preview — live app uses interactive Leaflet map with geocoded stops.
        </p>
      </section>

      <section className="dp-panel">
        <h2 className="dp-panel__title">Stops</h2>
        <table className="dp-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Stop</th>
              <th>Type</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>—</td>
              <td>
                <strong>{SAMPLE_LOAD.assignments.depot}</strong>
              </td>
              <td>
                <span className="dp-badge dp-badge--depot">Depot</span>
              </td>
              <td className="dp-table__muted">Chattanooga, TN</td>
            </tr>
            {SAMPLE_STOPS.map((stop) => (
              <tr key={stop.sequence}>
                <td>{stop.sequence}</td>
                <td>
                  <strong>{stop.label}</strong>
                </td>
                <td>
                  <span className={`dp-badge dp-badge--${stop.type}`}>{stop.type}</span>
                </td>
                <td className="dp-table__muted">{stop.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>

    <div className="dp-publish-bar">
      <div>
        <strong>Driver-ready</strong>
        <span className="dp-publish-bar__meta">
          Plan published · share link or send to mobile
        </span>
      </div>
      <button type="button" className="dp-btn dp-btn--primary">
        Copy driver link
      </button>
    </div>
  </div>
);

export default RoutePlanPreview;
